import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import ExtensionOutlinedIcon from '@mui/icons-material/ExtensionOutlined';

export const getTabIcon = (tabId: string) => {
  switch (tabId) {
    case "personal":
      return <BadgeOutlinedIcon fontSize="inherit" />;
    case "education":
      return <SchoolOutlinedIcon fontSize="inherit" />;
    case "experience":
      return <WorkOutlineOutlinedIcon fontSize="inherit" />;
    case "projects":
      return <FolderOpenOutlinedIcon fontSize="inherit" />;
    case "skills":
      return <BoltOutlinedIcon fontSize="inherit" />;
    case "certifications":
      return <EmojiEventsOutlinedIcon fontSize="inherit" />;
    case "custom":
      return <ExtensionOutlinedIcon fontSize="inherit" />;
    case "templates":
      return <DashboardCustomizeOutlinedIcon fontSize="inherit" />;
    default:
      return null;
  }
};

